import { Component, inject, Inject } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DisbursmentService } from 'src/app/shared/service/disbursment/disbursment.service';
import { allowOnlyLetters, allowLimitedInput } from '../../master.utils';
import { MaCountry } from '../create-port-tariff/country.model';
import { ToastrService } from 'ngx-toastr';
import { atLeastOneFieldRequiredValidator } from '../../../master-tabs/pages/tariff-services/tariff-service.model';
import { TariffService } from 'src/app/shared/service/disbursment/tariff-services.service';

@Component({
  selector: 'app-create-tariff-service',
  templateUrl: './create-tariff-service.component.html',
  styleUrls: ['./create-tariff-service.component.scss']
})
export class CreateTariffServiceComponent {

 private loader = inject(DisbursmentService);
 isLoading$ = this.loader.loading$;
  disallowNumericData = allowOnlyLetters;
  allowLimitedInput = allowLimitedInput;
  serviceForm: FormGroup;
  isEditMode = false;
  countryData: MaCountry[] = [];

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<CreateTariffServiceComponent>,
    @Inject(MAT_DIALOG_DATA) public existingdata: any,
    private tariffService: TariffService,
    // private countryService: CountryService,
    private snackBar: ToastrService
  ) {
    const data = existingdata?.rowData;
    this.isEditMode = !!data;
    this.serviceForm = this.fb.group({
      service_id: [data?.service_id ?? null],
      service_name: [data?.service_name || '', Validators.required],
      fields: this.fb.array(
        (data?.fields ?? []).map((field: any) =>
          this.fb.group({
            name: [field.name || ''],
            data_type: [field.data_type || ''],
            nullable: [field.nullable || 'Optional'],
          })
        ),
        [atLeastOneFieldRequiredValidator]
      )
    });

  }

  // onPaste(event: ClipboardEvent): void {
  //   const value = handlePasteText(event);
  //   this.serviceForm.get('type')?.setValue(value);
  // }

  ngOnInit() {
    // this.getMaCountryDataFromDb();
  }
  get fields() {
    return this.serviceForm.get('fields') as any;
  }

  // method to add the additional fields
  addField() {
    this.fields.push(
      this.fb.group({
        name: ['', Validators.required],
        data_type: ['', Validators.required],
        nullable: ['',],

      })
    )
  }

  removeField(index: number) {
    if (index >= 0) {
      this.fields.removeAt(index);
    }
  }

  // onSubmit method will trigger when the Add or Edit  button clicks
  onSubmit() {
    if (atLeastOneFieldRequiredValidator(this.fields)) {
      // this.fields.markAsTouched();
      this.snackBar.error('At least one field is required.');
      return;
    }

    if (this.fields.invalid) {
      this.fields.markAsTouched();
      this.snackBar.error('Please fill the required fields');
      return;
    }
    if (this.serviceForm.valid) {
      this.loader.show();
      this.tariffService.ServiceDataToDB(this.serviceForm.value).subscribe({
        next: (res) => {
          this.loader.hide();
          this.snackBar.success(res.message);
          this.dialogRef.close("refresh");
        },
        error: (error) => {
          this.loader.hide();
          const errorMsg = error.error?.error || 'Something went wrong. Please try again.';
          this.snackBar.error(errorMsg);
        }
      })
    }
  }

  // method to get the countrylist
  // getMaCountryDataFromDb() {
  //   const body = {
  //     fields: [
  //       "country"
  //     ]

  //   }
  //   this.loader.show();
  //   this.countryService.MaCountryDataFromDb(body).subscribe({
  //     next: (response: any) => {
  //       this.countryData = response;
  //       this.loader.hide();
  //     },
  //     error: (err) => {
  //       console.error('Error fetching countries:', err);
  //       this.loader.hide();
  //     }
  //   });
  // }

  closeDialog() {
    this.dialogRef.close("");
  }
}
